import { SubmissionActionConstants } from '../constants';

const next_question = (state = 0, action) => {
  if (action.type === SubmissionActionConstants.SKIP_QUESTION && state > 0) {
    return state + 1;
  }

  if (action.type === SubmissionActionConstants.LOADING_SUBMISSION) {
    return 1;
  }  

  if (action.type === SubmissionActionConstants.SUBMISSION_RECEIVED && action.submission.next_question > state) {
    return action.submission.next_question;
  }  

  return state;
};

export default next_question;


// WEBPACK FOOTER //
// ./src/reducers/next_question.js